export default "__VITE_ASSET__DPg1edp$__"